export const FETCH_PAST_EVENT_DATA = 'FETCH_PAST_EVENT_DATA';
export const FETCH_BASIC_DATA = 'FETCH_BASIC_DATA';
export const FETCH_GA_DATA = 'FETCH_GA_DATA';
export const FETCH_BRIZI_VISION_DATA = 'FETCH_BRIZI_VISION_DATA';
export const SET_TIMELINE_INTERVAL = 'SET_TIMELINE_INTERVAL';
